import type { Translations } from '../../types'

const commonMessages: Translations = {
  "common.close": "Chiudi",
  "common.enabled": "Attivo",
  "common.disabled": "Disattivo",
  "common.on": "ON",
  "common.off": "OFF",
  "common.loading": "Caricamento…",
  "common.cancel": "Annulla",
  "common.confirm": "Conferma",
  "common.wait": "Attendere...",
  "common.or": "oppure",
  "common.pagination.show": "Mostra",
  "common.pagination.results": "risultati",
  "common.pagination.page": "Pagina",
  "common.pagination.previous": "Precedente",
  "common.pagination.next": "Successiva"
}

export default commonMessages
